module.exports = __webpack_public_path__ + "static/media/power-bi-dashboard.56597480.png";